// Thu Mar 27 06:04:36 GMT 2025

import * as models from "../crm-web-api-models"

export enum RegistrationProp {
	AppSource = 'appSource',
	AppsFlyerID = 'appsFlyerID',
	CompanySelection = 'companySelection',
	CreationTime = 'creationTime',
	CustomerId = 'customer.id',
	CustomerRegistrationsCount = 'customer.registrationsCount',
	Id = 'id',
	KissmetricsUid = 'kissmetricsUid',
	MarketingParamsAdGroup = 'marketingParams.adGroup',
	MarketingParamsAdId = 'marketingParams.adId',
	MarketingParamsAdSize = 'marketingParams.adSize',
	MarketingParamsAdditionalAffiliateData = 'marketingParams.additionalAffiliateData',
	MarketingParamsAffTrackingCode = 'marketingParams.affTrackingCode',
	MarketingParamsCampaign = 'marketingParams.campaign',
	MarketingParamsCategory = 'marketingParams.category',
	MarketingParamsContent = 'marketingParams.content',
	MarketingParamsCount = 'marketingParams.count',
	MarketingParamsCreativeId = 'marketingParams.creativeId',
	MarketingParamsExternalReferrer = 'marketingParams.externalReferrer',
	MarketingParamsGclid = 'marketingParams.gclid',
	MarketingParamsIntentGroup = 'marketingParams.intentGroup',
	MarketingParamsIntentInstrument = 'marketingParams.intentInstrument',
	MarketingParamsInternalReferrer = 'marketingParams.internalReferrer',
	MarketingParamsMedium = 'marketingParams.medium',
	MarketingParamsReferrer = 'marketingParams.referrer',
	MarketingParamsRegistrationServiceType = 'marketingParams.registrationServiceType',
	MarketingParamsSemMt = 'marketingParams.semMt',
	MarketingParamsSemPosition = 'marketingParams.semPosition',
	MarketingParamsSemSq = 'marketingParams.semSq',
	MarketingParamsSource = 'marketingParams.source',
	MarketingParamsTerm = 'marketingParams.term',
	MarketingParamsTrafficKey = 'marketingParams.trafficKey',
	MarketingParamsWebsite = 'marketingParams.website',
	RegistrationSource = 'registrationSource',
	RegistrationTarget = 'registrationTarget',
	TrafficSourceAffiliateId = 'trafficSource.affiliateId',
	TrafficSourceLandingPage = 'trafficSource.landingPage',
	TrafficSourceMedia = 'trafficSource.media',
	TrafficSourceNetwork = 'trafficSource.network',
	TrafficSourcePromotionName = 'trafficSource.promotionName',
	TrafficSourceSubAffiliate = 'trafficSource.subAffiliate',
	TrafficSourceTrafficId = 'trafficSource.trafficId',
	TrafficSourceZone = 'trafficSource.zone',
	Uid = 'uid'
}

export type RegistrationPropAppSource = {
	[RegistrationProp.AppSource] : 'COSMOS_WEB' | 'COSMOS_MOBILE_I_O_S' | 'COSMOS_MOBILE_ANDROID' | 'COSMOS_TABLET_I_O_S' | 'COSMOS_TABLET_ANDROID' | 'COSMOS_DESKTOP_WINDOWS' | 'COSMOS_MOBILE_WINDOWS' | 'INDIGO_WEB' | 'INDIGO_MOBILE_I_O_S' | 'INDIGO_MOBILE_ANDROID' | 'INDIGO_TABLET_I_O_S' | 'INDIGO_TABLET_ANDROID' | 'WRAPPER_MOBILE_IOS' | 'WRAPPER_MOBILE_ANDROID' | 'WRAPPER_TABLET_IOS' | 'WRAPPER_TABLET_ANDROID' | 'COSMOS_MOBILE_HUAWEI' | 'COSMOS_TABLET_HUAWEI' | null
}
export type RegistrationPropAppsFlyerID = {
	[RegistrationProp.AppsFlyerID] : string | null
}
export type RegistrationPropCompanySelection = {
	[RegistrationProp.CompanySelection] : boolean | null
}
export type RegistrationPropCreationTime = {
	[RegistrationProp.CreationTime] : number | null
}
export type RegistrationPropCustomerId = {
	[RegistrationProp.CustomerId] : number | null
}
export type RegistrationPropCustomerRegistrationsCount = {
	[RegistrationProp.CustomerRegistrationsCount] : number | null
}
export type RegistrationPropId = {
	[RegistrationProp.Id] : number
}
export type RegistrationPropKissmetricsUid = {
	[RegistrationProp.KissmetricsUid] : string | null
}
export type RegistrationPropMarketingParamsAdGroup = {
	[RegistrationProp.MarketingParamsAdGroup] : string | null
}
export type RegistrationPropMarketingParamsAdId = {
	[RegistrationProp.MarketingParamsAdId] : string | null
}
export type RegistrationPropMarketingParamsAdSize = {
	[RegistrationProp.MarketingParamsAdSize] : string | null
}
export type RegistrationPropMarketingParamsAdditionalAffiliateData = {
	[RegistrationProp.MarketingParamsAdditionalAffiliateData] : string | null
}
export type RegistrationPropMarketingParamsAffTrackingCode = {
	[RegistrationProp.MarketingParamsAffTrackingCode] : string | null
}
export type RegistrationPropMarketingParamsCampaign = {
	[RegistrationProp.MarketingParamsCampaign] : string | null
}
export type RegistrationPropMarketingParamsCategory = {
	[RegistrationProp.MarketingParamsCategory] : string | null
}
export type RegistrationPropMarketingParamsContent = {
	[RegistrationProp.MarketingParamsContent] : string | null
}
export type RegistrationPropMarketingParamsCount = {
	[RegistrationProp.MarketingParamsCount] : number | null
}
export type RegistrationPropMarketingParamsCreativeId = {
	[RegistrationProp.MarketingParamsCreativeId] : string | null
}
export type RegistrationPropMarketingParamsExternalReferrer = {
	[RegistrationProp.MarketingParamsExternalReferrer] : string | null
}
export type RegistrationPropMarketingParamsGclid = {
	[RegistrationProp.MarketingParamsGclid] : string | null
}
export type RegistrationPropMarketingParamsIntentGroup = {
	[RegistrationProp.MarketingParamsIntentGroup] : string | null
}
export type RegistrationPropMarketingParamsIntentInstrument = {
	[RegistrationProp.MarketingParamsIntentInstrument] : string | null
}
export type RegistrationPropMarketingParamsInternalReferrer = {
	[RegistrationProp.MarketingParamsInternalReferrer] : string | null
}
export type RegistrationPropMarketingParamsMedium = {
	[RegistrationProp.MarketingParamsMedium] : string | null
}
export type RegistrationPropMarketingParamsReferrer = {
	[RegistrationProp.MarketingParamsReferrer] : string | null
}
export type RegistrationPropMarketingParamsRegistrationServiceType = {
	[RegistrationProp.MarketingParamsRegistrationServiceType] : string | null
}
export type RegistrationPropMarketingParamsSemMt = {
	[RegistrationProp.MarketingParamsSemMt] : string | null
}
export type RegistrationPropMarketingParamsSemPosition = {
	[RegistrationProp.MarketingParamsSemPosition] : string | null
}
export type RegistrationPropMarketingParamsSemSq = {
	[RegistrationProp.MarketingParamsSemSq] : string | null
}
export type RegistrationPropMarketingParamsSource = {
	[RegistrationProp.MarketingParamsSource] : string | null
}
export type RegistrationPropMarketingParamsTerm = {
	[RegistrationProp.MarketingParamsTerm] : string | null
}
export type RegistrationPropMarketingParamsTrafficKey = {
	[RegistrationProp.MarketingParamsTrafficKey] : string | null
}
export type RegistrationPropMarketingParamsWebsite = {
	[RegistrationProp.MarketingParamsWebsite] : string | null
}
export type RegistrationPropRegistrationSource = {
	[RegistrationProp.RegistrationSource] : 'REGULAR' | 'GOOGLE_ONE_TAP' | 'GOOGLE_CONNECT' | 'FACEBOOK_CONNECT' | 'APPLE_SIGN_IN' | 'HUAWEI' | null
}
export type RegistrationPropRegistrationTarget = {
	[RegistrationProp.RegistrationTarget] : 'LEAD' | 'DEMO' | 'REAL' | 'REAL_FUNDED' | null
}
export type RegistrationPropTrafficSourceAffiliateId = {
	[RegistrationProp.TrafficSourceAffiliateId] : string | null
}
export type RegistrationPropTrafficSourceLandingPage = {
	[RegistrationProp.TrafficSourceLandingPage] : any /* Entity */
}
export type RegistrationPropTrafficSourceMedia = {
	[RegistrationProp.TrafficSourceMedia] : string | null
}
export type RegistrationPropTrafficSourceNetwork = {
	[RegistrationProp.TrafficSourceNetwork] : string | null
}
export type RegistrationPropTrafficSourcePromotionName = {
	[RegistrationProp.TrafficSourcePromotionName] : string | null
}
export type RegistrationPropTrafficSourceSubAffiliate = {
	[RegistrationProp.TrafficSourceSubAffiliate] : string | null
}
export type RegistrationPropTrafficSourceTrafficId = {
	[RegistrationProp.TrafficSourceTrafficId] : string | null
}
export type RegistrationPropTrafficSourceZone = {
	[RegistrationProp.TrafficSourceZone] : string | null
}
export type RegistrationPropUid = {
	[RegistrationProp.Uid] : string | null
}


export type Registration = 
	RegistrationPropAppSource & 
	RegistrationPropAppsFlyerID & 
	RegistrationPropCompanySelection & 
	RegistrationPropCreationTime & 
	RegistrationPropCustomerId & 
	RegistrationPropCustomerRegistrationsCount & 
	RegistrationPropId & 
	RegistrationPropKissmetricsUid & 
	RegistrationPropMarketingParamsAdGroup & 
	RegistrationPropMarketingParamsAdId & 
	RegistrationPropMarketingParamsAdSize & 
	RegistrationPropMarketingParamsAdditionalAffiliateData & 
	RegistrationPropMarketingParamsAffTrackingCode & 
	RegistrationPropMarketingParamsCampaign & 
	RegistrationPropMarketingParamsCategory & 
	RegistrationPropMarketingParamsContent & 
	RegistrationPropMarketingParamsCount & 
	RegistrationPropMarketingParamsCreativeId & 
	RegistrationPropMarketingParamsExternalReferrer & 
	RegistrationPropMarketingParamsGclid & 
	RegistrationPropMarketingParamsIntentGroup & 
	RegistrationPropMarketingParamsIntentInstrument & 
	RegistrationPropMarketingParamsInternalReferrer & 
	RegistrationPropMarketingParamsMedium & 
	RegistrationPropMarketingParamsReferrer & 
	RegistrationPropMarketingParamsRegistrationServiceType & 
	RegistrationPropMarketingParamsSemMt & 
	RegistrationPropMarketingParamsSemPosition & 
	RegistrationPropMarketingParamsSemSq & 
	RegistrationPropMarketingParamsSource & 
	RegistrationPropMarketingParamsTerm & 
	RegistrationPropMarketingParamsTrafficKey & 
	RegistrationPropMarketingParamsWebsite & 
	RegistrationPropRegistrationSource & 
	RegistrationPropRegistrationTarget & 
	RegistrationPropTrafficSourceAffiliateId & 
	RegistrationPropTrafficSourceLandingPage & 
	RegistrationPropTrafficSourceMedia & 
	RegistrationPropTrafficSourceNetwork & 
	RegistrationPropTrafficSourcePromotionName & 
	RegistrationPropTrafficSourceSubAffiliate & 
	RegistrationPropTrafficSourceTrafficId & 
	RegistrationPropTrafficSourceZone & 
	RegistrationPropUid

export const REGISTRATION_PROPERTY_NAMES = Object.freeze([RegistrationProp.AppSource, RegistrationProp.AppsFlyerID, RegistrationProp.CompanySelection, RegistrationProp.CreationTime, RegistrationProp.CustomerId, RegistrationProp.CustomerRegistrationsCount, RegistrationProp.Id, RegistrationProp.KissmetricsUid, RegistrationProp.MarketingParamsAdGroup, RegistrationProp.MarketingParamsAdId, RegistrationProp.MarketingParamsAdSize, RegistrationProp.MarketingParamsAdditionalAffiliateData, RegistrationProp.MarketingParamsAffTrackingCode, RegistrationProp.MarketingParamsCampaign, RegistrationProp.MarketingParamsCategory, RegistrationProp.MarketingParamsContent, RegistrationProp.MarketingParamsCount, RegistrationProp.MarketingParamsCreativeId, RegistrationProp.MarketingParamsExternalReferrer, RegistrationProp.MarketingParamsGclid, RegistrationProp.MarketingParamsIntentGroup, RegistrationProp.MarketingParamsIntentInstrument, RegistrationProp.MarketingParamsInternalReferrer, RegistrationProp.MarketingParamsMedium, RegistrationProp.MarketingParamsReferrer, RegistrationProp.MarketingParamsRegistrationServiceType, RegistrationProp.MarketingParamsSemMt, RegistrationProp.MarketingParamsSemPosition, RegistrationProp.MarketingParamsSemSq, RegistrationProp.MarketingParamsSource, RegistrationProp.MarketingParamsTerm, RegistrationProp.MarketingParamsTrafficKey, RegistrationProp.MarketingParamsWebsite, RegistrationProp.RegistrationSource, RegistrationProp.RegistrationTarget, RegistrationProp.TrafficSourceAffiliateId, RegistrationProp.TrafficSourceLandingPage, RegistrationProp.TrafficSourceMedia, RegistrationProp.TrafficSourceNetwork, RegistrationProp.TrafficSourcePromotionName, RegistrationProp.TrafficSourceSubAffiliate, RegistrationProp.TrafficSourceTrafficId, RegistrationProp.TrafficSourceZone, RegistrationProp.Uid])

export type RegistrationTab = 
	RegistrationPropId & 
	RegistrationPropCustomerId

export const REGISTRATION_TAB_PROPERTY_NAMES = Object.freeze([RegistrationProp.Id, RegistrationProp.CustomerId])

export type RegistrationHistoryTab = 
	RegistrationPropId & 
	RegistrationPropCustomerId

export const REGISTRATION_HISTORY_TAB_PROPERTY_NAMES = Object.freeze([RegistrationProp.Id, RegistrationProp.CustomerId])

export type RegistrationHeader = 
	RegistrationPropId & 
	RegistrationPropCustomerId & 
	RegistrationPropCustomerRegistrationsCount & 
	RegistrationPropMarketingParamsCount

export const REGISTRATION_HEADER_PROPERTY_NAMES = Object.freeze([RegistrationProp.Id, RegistrationProp.CustomerId, RegistrationProp.CustomerRegistrationsCount, RegistrationProp.MarketingParamsCount])

export type RegistrationGeneral = 
	RegistrationPropId & 
	RegistrationPropCustomerId & 
	RegistrationPropCustomerRegistrationsCount & 
	RegistrationPropMarketingParamsCount & 
	RegistrationPropCreationTime & 
	RegistrationPropRegistrationTarget & 
	RegistrationPropAppSource & 
	RegistrationPropRegistrationSource & 
	RegistrationPropCompanySelection

export const REGISTRATION_GENERAL_PROPERTY_NAMES = Object.freeze([RegistrationProp.Id, RegistrationProp.CustomerId, RegistrationProp.CustomerRegistrationsCount, RegistrationProp.MarketingParamsCount, RegistrationProp.CreationTime, RegistrationProp.RegistrationTarget, RegistrationProp.AppSource, RegistrationProp.RegistrationSource, RegistrationProp.CompanySelection])

export type RegistrationTrafficSource = 
	RegistrationPropId & 
	RegistrationPropTrafficSourceAffiliateId & 
	RegistrationPropTrafficSourceSubAffiliate & 
	RegistrationPropTrafficSourceNetwork & 
	RegistrationPropTrafficSourceMedia & 
	RegistrationPropTrafficSourceZone & 
	RegistrationPropTrafficSourceLandingPage & 
	RegistrationPropTrafficSourceTrafficId & 
	RegistrationPropTrafficSourcePromotionName

export const REGISTRATION_TRAFFIC_SOURCE_PROPERTY_NAMES = Object.freeze([RegistrationProp.Id, RegistrationProp.TrafficSourceAffiliateId, RegistrationProp.TrafficSourceSubAffiliate, RegistrationProp.TrafficSourceNetwork, RegistrationProp.TrafficSourceMedia, RegistrationProp.TrafficSourceZone, RegistrationProp.TrafficSourceLandingPage, RegistrationProp.TrafficSourceTrafficId, RegistrationProp.TrafficSourcePromotionName])

export type RegistrationMarketingParams = 
	RegistrationPropId & 
	RegistrationPropMarketingParamsAdGroup & 
	RegistrationPropMarketingParamsAdSize & 
	RegistrationPropMarketingParamsAdditionalAffiliateData & 
	RegistrationPropMarketingParamsAffTrackingCode & 
	RegistrationPropMarketingParamsCampaign & 
	RegistrationPropMarketingParamsCategory & 
	RegistrationPropMarketingParamsContent & 
	RegistrationPropMarketingParamsCreativeId & 
	RegistrationPropMarketingParamsGclid & 
	RegistrationPropMarketingParamsMedium & 
	RegistrationPropMarketingParamsReferrer & 
	RegistrationPropMarketingParamsInternalReferrer & 
	RegistrationPropMarketingParamsExternalReferrer & 
	RegistrationPropMarketingParamsSemMt & 
	RegistrationPropMarketingParamsSemPosition & 
	RegistrationPropMarketingParamsSemSq & 
	RegistrationPropMarketingParamsSource & 
	RegistrationPropMarketingParamsTerm & 
	RegistrationPropMarketingParamsWebsite & 
	RegistrationPropMarketingParamsRegistrationServiceType & 
	RegistrationPropMarketingParamsAdId & 
	RegistrationPropMarketingParamsTrafficKey & 
	RegistrationPropMarketingParamsIntentGroup & 
	RegistrationPropMarketingParamsIntentInstrument

export const REGISTRATION_MARKETING_PARAMS_PROPERTY_NAMES = Object.freeze([RegistrationProp.Id, RegistrationProp.MarketingParamsAdGroup, RegistrationProp.MarketingParamsAdSize, RegistrationProp.MarketingParamsAdditionalAffiliateData, RegistrationProp.MarketingParamsAffTrackingCode, RegistrationProp.MarketingParamsCampaign, RegistrationProp.MarketingParamsCategory, RegistrationProp.MarketingParamsContent, RegistrationProp.MarketingParamsCreativeId, RegistrationProp.MarketingParamsGclid, RegistrationProp.MarketingParamsMedium, RegistrationProp.MarketingParamsReferrer, RegistrationProp.MarketingParamsInternalReferrer, RegistrationProp.MarketingParamsExternalReferrer, RegistrationProp.MarketingParamsSemMt, RegistrationProp.MarketingParamsSemPosition, RegistrationProp.MarketingParamsSemSq, RegistrationProp.MarketingParamsSource, RegistrationProp.MarketingParamsTerm, RegistrationProp.MarketingParamsWebsite, RegistrationProp.MarketingParamsRegistrationServiceType, RegistrationProp.MarketingParamsAdId, RegistrationProp.MarketingParamsTrafficKey, RegistrationProp.MarketingParamsIntentGroup, RegistrationProp.MarketingParamsIntentInstrument])

export type RegistrationAppsFlyerParams = 
	RegistrationPropId & 
	RegistrationPropUid & 
	RegistrationPropAppsFlyerID

export const REGISTRATION_APPS_FLYER_PARAMS_PROPERTY_NAMES = Object.freeze([RegistrationProp.Id, RegistrationProp.Uid, RegistrationProp.AppsFlyerID])

export type RegistrationKissMetricsParams = 
	RegistrationPropId & 
	RegistrationPropKissmetricsUid

export const REGISTRATION_KISS_METRICS_PARAMS_PROPERTY_NAMES = Object.freeze([RegistrationProp.Id, RegistrationProp.KissmetricsUid])
